import { useContext } from 'react'
import { FilteredJobsSkeleton } from '../components/FilteredJobsSkeleton'
import Card from 'antd/lib/card'
import List from 'antd/lib/list'
import { SharedContext } from '@/context/SharedContext'

const listData = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }]

export const JobsFilteringSkeletonLoading = ({ visible = true }) => {
  const { windowSize } = useContext(SharedContext)

  return (
    visible && (
      <>
        <div className="flex items-center overflow-hidden sm:max-w-[500px] md:max-w-full">
          {(windowSize < 1100 ? listData?.slice(0, 2) : listData)?.map((item, index) => (
            <Card className="mx-[12px] my-[12px] h-fit w-[320px]" key={index}>
              <FilteredJobsSkeleton />
            </Card>
          ))}
        </div>
        <List
          itemLayout="vertical"
          size="large"
          dataSource={listData}
          className="sm:w-[500px] md:w-[746px]"
          renderItem={(item) => (
            <Card className="mx-[12px] my-[12px]">
              <FilteredJobsSkeleton />
            </Card>
          )}
          rowKey={(item) => item?.id}
        />
      </>
    )
  )
}
